import { FC, PropsWithChildren } from "react";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import { theme } from "antd";
import { useClientSettings } from "@hooks/useClientSettings";

const ThemeProvider: FC<PropsWithChildren> = (props) => {
  const { token } = theme.useToken();
  const client = useClientSettings();

  return <StyledComponentsThemeProvider theme={{ token, client }} {...props} />;
};

export default ThemeProvider;
